import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

import classes from "./ClientDetails.module.scss";

interface WelcomeModalProps {
  showModal: boolean;
  setModalState: (state: boolean) => void;
}

export const WelcomeModal = ({
  setModalState,
  showModal,
}: WelcomeModalProps) => {
  return (
    <Dialog
      visible={showModal}
      onHide={() => setModalState(false)}
      header="Welcome to DCS! "
      draggable={false}
      className={classes["welcome-modal"]}
    >
      <p className={classes.info}>
      Congratulations! You've been successfully added to the DOS app. 
      We are working on your proposal, we invite you to join by clicking here. 
      Use the one-time password provided to gain instant access.<br/> We look forward to working with you.
      </p>
      <Button
        style={{ display: "block", margin: "auto", marginTop: 40 }}
        onClick={() => setModalState(false)}
        label="Confirm"
        className="p-button-primary"
        type="button"
      />
    </Dialog>
  );
};

export default WelcomeModal;
